import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Navbar from '../Navbar';
import Navbar2 from '../Navbar2';
import './ProductDetails.css'
import { useCart } from '../../context/CartContext';
import { useWishlist } from '../../context/WishlistContext';
import Footer from '../Footer/Footer';

function ProductDetails() {

    // const location = useLocation();
    // const {itemData} = location.state || {};

    const { id } = useParams();
    const navigate = useNavigate();
    const [product, setProduct] = useState(null);
    const [loading, setLoading] = useState(true);
    const [relatedProducts, setRelatedProducts] = useState([]);
    const [selectedSize, setSelectedSize] = useState(null);
    const [selectedQuantity, setSelectedQuantity] = useState(1);
    const [availableQuantities, setAvailableQuantities] = useState([]);

    const { cartItems, addToCart, removeFromCart } = useCart();
    const { addToWishlist, removeFromWishlist, isInWishlist } = useWishlist();
    // const [isInWishlist, setIsInWishlist] = useState(false);

    const currentCartItem = cartItems.find(item => item._id === product?._id && item.size === selectedSize);
    const quantity = currentCartItem?.quantity || 0;

    useEffect(() => {
        fetch(`http://localhost:3001/api/products/${id}`)
            .then(res => res.json())
            .then(data => {
                setProduct(data);
                setLoading(false);
                // Fetch related products
                fetch(`http://localhost:3001/api/products/department/${encodeURIComponent(data.department)}`)
                    .then(res => res.json())
                    .then(related => {
                        const filtered = related.filter(p => p._id !== data._id).slice(0, 4);
                        setRelatedProducts(filtered);
                    })
                    .catch(err => console.error("Error fetching related products:", err));
            })
            .catch(err => {
                console.error("Error fetching Product Detial: ", err);
                setLoading(false);
            });
    }, [id]);

    useEffect(() => {
        if(selectedSize && product) {
            const cartQuantity = currentCartItem?.quantity || 0;
            const remainingStock = product.quantity - cartQuantity;
            const maxDisplayQuantity = Math.min(5, remainingStock);
            const quantities = Array.from({length: maxDisplayQuantity}, (_, i) => i+1);
            setAvailableQuantities(quantities);
            setSelectedQuantity(1);
        }
    }, [selectedSize, product, currentCartItem])

    const handleAddToCart = () => {
        if (!selectedSize) {
            alert("Please select a size first");
            return;
        }

        if (product.quantity <= 0) {
            alert("This product is out of stock");
            return;
        }
        addToCart({
            ...product,
            size: selectedSize,
            quantity: selectedQuantity,
            stock: product.quantity, // Pass the available stock to cart
            price: product.price.discounted,
            image: `http://localhost:3001/uploads/${product.images[0]}`,
            title: `${product.brand} - ${product.productType} (${selectedSize})`
        });
    }

    const handleRemoveFromCart = () => {
        removeFromCart(product._id, selectedSize);
    }

    const toggleWishlist = () => {
        if (isInWishlist(product._id)) {
            removeFromWishlist(product._id);
        } else {
            addToWishlist({
                ...product,
                _id: product._id,
                title: `${product.brand} - ${product.productType}`,
                price: product.price.discounted,
                image: `http://localhost:3001/uploads/${product.images[0]}`,
                brand: product.brand,
                productType: product.productType,
                description: product.description
            });
        }
    }

    const parseSizes = (sizeString) => {
        return sizeString.split(',').map(size => size.trim());
    }

    if (loading) {
        return (
            <>
                <Navbar />
                <div className="sticky-navbar">
                    <Navbar2 />
                </div>
                <div className="loading-container">
                    <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            </>
        );
    }

    if (!product) {
        return (
            <>
                <Navbar />
                <div className="sticky-navbar">
                    <Navbar2 />
                </div>
                <div className="container py-5 text-center">
                    Product not found
                </div>
            </>
        );
    }

    return (
        <>
            <Navbar />
            <div className="sticky-navbar">
                <Navbar2 />
            </div>
            <h4 className="section-title">Products Details Page</h4>
            <div className="product-details-container container py-5">
                <div className="row">
                    <div className="col-md-6">
                        <div className="product-image-container">
                            {product.images && product.images.length > 0 && (
                                <img
                                    src={`http://localhost:3001/uploads/${product.images[0]}`}
                                    alt={product.description}
                                    className="product-image img-fluid"
                                />
                            )}
                        </div>
                    </div>
                    <div className="col-md-6">
                        <h1 className="product-title">{product.brand} - {product.productType}</h1>
                        <p className="product-category">{product.category}</p>
                        <h2 className="product-price mb-4">
                            <span className="current-price">₹{product.price.discounted}</span>
                            <span className="original-price">₹{product.price.actual}</span>
                            <span className="discount-percent">({product.price.discount}% OFF)</span>
                        </h2>
                        <p className="product-description">{product.description}</p>
                        
                        {/* Size Selection */}
                        <div className="size-selection mb-4">
                            <h5>Select Size:</h5>
                            <div className="size-options">
                                {product?.size && parseSizes(product.size).map(size => (
                                    <button
                                    key={size}
                                    className={`size-option ${selectedSize === size ? 'selected' : ''}`}
                                    onClick={() => setSelectedSize(size)}
                                    >
                                        {size}
                                    </button>
                                ))}
                            </div>
                        </div>

                        {/* Quantity Selection */}
                        {selectedSize && (
                            <div className="quantity-selection mb-4">
                                <h5>Select Quantity:</h5>
                                <div className="quantity-options">
                                    {availableQuantities.map(qty => (
                                        <button
                                            key={qty}
                                            className={`quantity-option ${selectedQuantity === qty ? 'selected' : ''}`}
                                            onClick={() => setSelectedQuantity(qty)}
                                        >
                                            {qty}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        )}

                        <div className="product-actions mt-4">
                            {quantity > 0 ? (
                                <div className="quantity-control d-flex align-items-center">
                                    <button
                                        className="btn btn-outline-primary"
                                        onClick={handleRemoveFromCart}
                                    >
                                        -
                                    </button>
                                    <span className="mx-3">{quantity}</span>
                                    <button
                                        className="btn btn-outline-primary"
                                        onClick={handleAddToCart}
                                        disabled={quantity >= product.quantity}
                                    >
                                        +
                                    </button>
                                </div>
                            ) : (
                                <button
                                    className="btn btn-primary btn-lg me-3"
                                    onClick={handleAddToCart}
                                    disabled={product?.quantity <= 0 || !selectedSize}
                                >
                                    {!selectedSize ? 'Select Size' : 
                                     product?.quantity <= 0 ? 'Out of Stock' : 'Add to Cart'}
                                </button>
                            )}

                            <button
                                className={`btn btn-lg ${isInWishlist(product._id) ? 'btn-success' : 'btn-outline-secondary'}`}
                                onClick={toggleWishlist}
                            >
                                {isInWishlist(product._id) ? 'In Wishlist' : 'Add to Wishlist'}
                            </button>
                        </div>
                    </div>
                </div>

                {relatedProducts.length > 0 && (
                    <div className="related-products mt-5">
                        <h3 className="mb-4">You may also like</h3>
                        <div className="row">
                            {relatedProducts.map(related => (
                                <div className="col-md-3 col-sm-6 mb-4" key={related._id}>
                                    <div
                                        className="card h-100"
                                        onClick={() => navigate(`/product/${related._id}`)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        {related.images && related.images.length > 0 && (
                                            <img
                                                src={`http://localhost:3001/uploads/${related.images[0]}`}
                                                className="card-img-top related-product-image"
                                                alt={related.description}
                                            />
                                        )}
                                        <div className="card-body">
                                            <h5 className="card-title">{related.brand}</h5>
                                            <p className="card-text">{related.productType}</p>
                                            <p className="price">
                                                ₹{related.price.discounted}
                                                <span className="original-price">₹{related.price.actual}</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
            <Footer />
        </>
    )
}

export default ProductDetails